module.exports = __webpack_public_path__ + "img/terroir-choppy-1-mobile.d3d2f0e1.jpg";